var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAwaken6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2051_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.82843 19.7991C1.26633 18.237 1.26633 15.7044 2.82843 14.1423L14.1421 2.82857C15.7042 1.26647 18.2369 1.26647 19.799 2.82857L31.1127 14.1423C32.6748 15.7044 32.6748 18.237 31.1127 19.7991L19.799 31.1128C18.2369 32.6749 15.7042 32.6749 14.1421 31.1128L2.82843 19.7991Z",
    fill: "url(#paint0_linear_2051_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5963 19.72H11.2603V17.352H8.94031V15.144H11.2603V12.808H13.5963V15.144H15.9163V17.352H13.5963V19.72ZM23.4864 10.28V13.384H21.0864V11.624L20.7984 11.336H19.3424L19.0864 11.624V14.984H22.3504L23.4864 16.12V22.424L22.3504 23.56H17.8224L16.6864 22.424V10.28L17.8224 9.128H22.3504L23.4864 10.28ZM19.3424 21.352H20.7984L21.0864 21.08V17.448L20.7984 17.192H19.3424L19.0864 17.448V21.08L19.3424 21.352Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2051_1058",
    x: 0.65625,
    y: 0.657227,
    width: 31.6289,
    height: 31.627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2051_1058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2051_1058",
    x1: 8.48528,
    y1: 8.48542,
    x2: 25.4558,
    y2: 25.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12A4BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAwaken6);
export default __webpack_public_path__ + "static/media/ic_awaken_6.74d214f1cffc77e4685f313f0c384fad.svg";
export { ForwardRef as ReactComponent };